let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("i2b1G")).then(() => parcelRequire('ejvGh'));